import React from 'react';
import BannerPageOut from 'img/bg-page-out.svg';
import CompaniesHorizontal from 'img/ccare-rodape.png';

import './styles.scss';

const PageOut: React.FC = () => {
  return (
    <>
      <img
        className="banner-page-out"
        src={BannerPageOut}
        alt="banner em manutenção"
      />
      <img
        className="companies-page-out"
        src={CompaniesHorizontal}
        alt="banner em manutenção"
      />
    </>
  );
};

export default PageOut;